/**
 * What a signed-in adult may do inside their household.
 *
 * A household has exactly one head — the address that created it — and any
 * number of adults the head has since given a sign-in of their own. The two
 * differ only where an action cannot be undone: an adult reports, amends and
 * keeps the roster, but never erases the household or takes away a sign-in.
 */
export enum HouseholdRole {
  Head = "head",
  Adult = "adult",
}
